import { RouteInfo } from '../vertical-menu/vertical-menu.metadata';
import { decryptValue } from '../data/encryption'

export const HROUTES: RouteInfo[] = [

  // {
  //   path: '/dashboard', title: 'Dashboard', icon: 'ft-file-text', class: '', badge: '', badgeClass: '', isExternalLink: false, Role: true,
  //   submenu: [
  //   ]
  // },
  // {
  //   path: '', title: 'Expenses / Invoices', icon: 'ft-file-text', class: 'dropdown nav-item has-sub', badge: '', badgeClass: '', isExternalLink: false, Role: true,
  //   submenu: [
  //     { path: '/invoices/new/:status', title: 'Details', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
  //     { path: '/invoices/reportsPage', title: 'Reports Page', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
  //     // { path: '/myinvoices/inProgress', title: 'My invoices', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
  //   ]
  // },
  {
    path: '', title: 'Admin', icon: 'ft-aperture', class: 'dropdown nav-item has-sub', badge: '', badgeClass: '', isExternalLink: false, Role: IsInRole('ADMIN'),
    submenu: [
      {
        path: '', title: 'Users', icon: 'icon-users', class: 'dropdown nav-item has-sub', badge: '', badgeClass: '', isExternalLink: false, Role: true,
        submenu: [
          { path: '/admin/register', title: 'Register User', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
          { path: '/admin/view-user', title: 'User Details', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] }
        ]
      },
      { path: '/admin/roles', title: 'Roles', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
      { path: '/admin/add-sample-point', title: 'Add Sample Point', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
      { path: '/admin/add-operator', title: 'Add Operator', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
      { path: '/admin/add-reasons', title: 'Add Reasons', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
      { path: '/admin/add-metalBoxDetails', title: 'Add Metal Box Details', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
      { path: '/admin/metalBoxDetails', title: 'Metal Box Details', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
      { path: '/admin/report-config', title: 'Report Configuration', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
      { path: '/admin/sample-config', title: 'Sample Configuration', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
      { path: '/admin/generate-QRCode', title: 'Generate QR Code', icon: 'ft-arrow-right', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
    ]
  },
  {
    path: '', title: 'Lab Samples', icon: 'ft-database', class: 'dropdown nav-item has-sub', badge: '', badgeClass: '', isExternalLink: false, Role: true,
    submenu: [
    { path: '/sample/dashboard', title: 'Dashboard', icon: 'ft-home', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
    { path: '/sample/add', title: 'Add Sample', icon: 'ft-folder-plus', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
    { path: '/sample/addboxData', title: 'Add Box Data', icon: 'ft-folder-plus', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
    { path: '/sample/listing', title: 'View All Samples', icon: 'ft-book-open', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
    { path: '/sample/upload-ascii', title: 'Upload ASCII', icon: 'ft-upload', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
    { path: '/sample/ascii-audits', title: 'ASCII Audits', icon: 'ft-book-open', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
    { path: '/sample/archived', title: 'Archived Samples', icon: 'ft-book-open', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },
    { path: '/sample/cylinderBoxInventoryList', title: 'Cylinder Box Inventory Details', icon: 'ft-book-open', class: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, Role: true, submenu: [] },

    ]
  },
];


function IsInRole(role: string) {
  let roles = [];
  try {
    const encryptedRoles = localStorage.getItem('Roles');
    if (encryptedRoles) {
      const decryptedRoles = decryptValue(encryptedRoles);
      if (decryptedRoles) {
        roles = JSON.parse(decryptedRoles);
      }
    }
    // var roles = localStorage.getItem('Roles') && decryptValue(localStorage.getItem('Roles')) != null ? JSON.parse(decryptValue(localStorage.getItem('Roles'))) : [];

  } catch (error) {
    roles = []
  }
  if (roles.includes(role)) {
    return true;
  } else {
    return false;
  }
}

// function IsInRoleAlias(role: string) {
//   var roles = decryptValue(localStorage.getItem('RoleAliasName')) != null ? JSON.parse(decryptValue(localStorage.getItem('RoleAliasName'))) : [];
//   if (roles.includes(role)) {
//     return true;
//   } else {
//     return false;
//   }
// }
